module.exports = __webpack_public_path__ + "img/plan-advanced.fc4555f2.png";